<template>
  <ul class="az-list">
    <li v-for="letter in az" :key="letter" :class="{ 'active': letter === getLetter }" @click="$router.push(`/topics/${letter}`)">
      {{ letter | upper }}
    </li>
  </ul>
</template>


<script>
export default {
  data() {
    return {
      az: "ABCDEFGHIJKLMNOPQRSTUVWXYZ".toLocaleLowerCase().split(''),
    };
  },

  computed: {
    getLetter() {
      return this.$route.params.subgroup; 
    }
  },
}
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .az-list {
    position: sticky;
    top: 0;
    background: $neutral-600;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba($neutral-400, 0.25);
    padding: 1rem;
    width: 100%;
    overflow-x: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      display: none;
    }

    .darkmode & {
      background: $neutral-100;
    }

    li {
      padding: 0.75rem 0.75rem 0.75rem 0.75rem;
      font-weight: bold;
      border-radius: 500px;
      transition: all 0.2s ease-in-out;
      cursor: pointer;

      &:hover {
        background: rgba($neutral-400, 0.15);
      }

      &.active {
        background: rgba($neutral-400, 0.25);
      }
    }
  }
</style>